import { max } from "date-fns";
import { Context } from "../../../index";
import { useContext, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { manualBtnSound } from "../../../Utils/sounds";
import sound_play from "../../../Utils/sound_play";

function ManualBet({ styles, allow_max_bet, ButtonsChoiceFastSum, setAmount, setIndexSelectedButtonsSum, amount, indexSelectedButtonsSum }) {
    const { store } = useContext(Context)
    const min_bet = 1;
    const max_bet = 10000;
    const [startAmount, setStateAmount] = useState(true);
    useEffect(() => {

        if (startAmount && store.user.balance) {
            setAmount(Math.min(10,store.user.balance))
            setStateAmount(false)
        }
    }, [store.user.balance])
    useEffect(() => {
        if (!startAmount) {
            setAmount(prev => parseFloat(Number(amount).toFixed(2)))

        }
    }, [amount])


    return (<div className={styles.bet_container}>
        <div className="manual-bet manual-bet_wheel" style={{ minWidth: "100px" }}>
            <div className="manual-bet__form bet-form">
                <label className="bet-form__label">{store.dataLang["enter_sum_header"]}</label>
                <div _ngcontent-ng-c3106557790="" className="bet-form__wrapper">
                    <span _ngcontent-ng-c3106557790=""
                        className="bet-form__currency currency_USD"></span>
                    <input _ngcontent-ng-c3106557790="" value={amount > 0 ? amount : ""}
                        onChange={e => setAmount(e.target.value)} autoComplete="off" id="bet-amount"
                        className="bet-form__input ng-untouched ng-pristine ng-valid" type="number" min={min_bet} max={max_bet}
                        placeholder={store.isPhone ? store.dataLang["enter_sum"] : ""} />
                    <div className="button_manual_right" onClick={() => {
                        sound_play(manualBtnSound, store.sound);

                        setAmount(prev => Math.max(prev / 2, min_bet))
                    }}>1/2</div>
                    <div className="button_manual_right" onClick={() => {
                        sound_play(manualBtnSound, store.sound);
                        ; setAmount(prev => Math.min(Math.min(10000, store.user.balance), prev * 2))
                    }}>x2</div>
                    <span className="fa-solid fa-trash" onClick={() => {
                        sound_play(manualBtnSound, store.sound);
                        setIndexSelectedButtonsSum(0)
                        setAmount(0)
                    }}></span>
                </div>

            </div>
            <div _ngcontent-ng-c3106557790="" className="manual-bet__actions">

                {ButtonsChoiceFastSum.map((value, index) =>
                    <button onClick={(e) => {
                        sound_play(manualBtnSound, store.sound);

                        setIndexSelectedButtonsSum(index)
                        setAmount(parseFloat(amount) + ButtonsChoiceFastSum[index])
                    }} key={index} _ngcontent-ng-c3106557790="" type="button"
                        className={"manual-bet__action btnBet " + (index === indexSelectedButtonsSum ? "is-active" : "")}>
                        <div _ngcontent-ng-c3106557790="" className="btn__text currency_USD">+{value}</div>
                    </button>
                )}
                <button onClick={(e) => {
                    sound_play(manualBtnSound, store.sound);

                    setIndexSelectedButtonsSum(ButtonsChoiceFastSum.length)
                    setAmount(store.user.balance < max_bet ? store.user.balance : max_bet)
                }} _ngcontent-ng-c3106557790="" type="button"
                    className={"manual-bet__action btnBet " + (ButtonsChoiceFastSum.length === indexSelectedButtonsSum ? "is-active" : "")}>
                    <div _ngcontent-ng-c3106557790=""
                        className="btn__text currency_USD">Max
                    </div>
                </button>

            </div>

        </div>


    </div>
    )
}
export default observer(ManualBet)
